module.exports = __webpack_public_path__ + "static/media/BladeRX_789-A3_adapter_install.744bcc63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/BladeRX_789-A3_adapter_install.jpg
// module id = 826
// module chunks = 0